<template>
    <div v-if="mainPlacement != null">
        <placement-header :placement="mainPlacement" :index="0"></placement-header>
        <div v-for="option in styleOptions"
            :key="option.value"
            class="mt-4"
        >
            <base-checkbox
                :checkbox-id="option.value"
                :value="option.value === selectedValue"
                @change="updatePaintfill(option)"
            >
                {{option.label}} <span>{{formatPrice(option)}}</span>
            </base-checkbox>
        </div>

        <transition name="cz3__fade">
            <div v-if="!selectedPlaceholder"
                class="mt-8"
            >
                <initials-input
                    :limit="textLimit"
                    :characters="textCharacters.replace(/|||/g, '')"
                    :placement="mainPlacement"
                    attribute="v-etching-text-1"
                />

                <characters-list
                    v-if="allowedCharacters"
                    :characters="allowedCharacters"
                />
            </div>
        </transition>
    </div>
</template>

<script>
    import CharactersList from './CharactersList.vue';
    import PlacementHeader from './PlacementHeader.vue';
    import BaseCheckbox from './BaseCheckbox.vue';
    import InitialsInput from './InitialsInput.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            CharactersList,
            PlacementHeader,
            BaseCheckbox,
            InitialsInput,
        },

        props: {
            itemData: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                paintfillEnabled: false,
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            visiblePlacements() {
                const placements = this.customizerStore.visiblePlacements(this.itemData) ?? [];

                return placements.map((placement) => {
                    const selected = this.viewController.selectedAtPlacement(placement.code);

                    // Add extra properties to each placement:
                    // - a code of the currently selected component.
                    return {
                        selectedValue: selected ? selected.code : null,
                        selectedPlaceholder: selected ? selected.placeholder : null,
                        groupType: placement.custom?.['v-group-type'] ?? 'standard-buttons',
                        ...placement,
                    };
                });
            },

            mainPlacement() {
                return this.visiblePlacements.find((x) => x.code === 'LaserEtching');
            },

            selectedValue() {
                return this.mainPlacement.selectedValue;
            },

            selectedPlaceholder() {
                return this.mainPlacement.selectedPlaceholder;
            },

            styleOptions() {
                return this.customizerStore.sortOptions(this.mainPlacement, this.selectedValue);
            },

            currentComponent() {
                return this.viewController.selectedAtPlacement(this.mainPlacement.code);
            },

            textCharacters() {
                return this.currentComponent?.custom['v-etching-characters'];
            },

            allowedCharacters() {
                const characters = this.textCharacters;

                if (characters) {
                    return characters.split('|||').map((line) => line.split(''));
                }

                return null;
            },

            textLimit() {
                const limit = this.mainPlacement.custom?.['v-etching-limit'];

                if (limit != null) {
                    return +limit;
                }

                const ownLimit = this.currentComponent?.custom?.['v-etching-limit'];

                return +ownLimit;
            },
        },

        methods: {
            selectValue(placement, option) {
                this.customizerStore.setSelection(placement.code, option.value, false);
            },

            updatePaintfill(option) {
                this.viewController.updateComponent(this.mainPlacement.code, option.value);
            },

            formatPrice(option) {
                return this.customizerStore.priceFormatted(
                    this.customizerStore.getPrice(this.viewController, option.raw),
                    true,
                );
            },
        },
    };
</script>
